import { TViewCategoryAction, ViewCategoryActionTypes } from './viewCategoryActions';
import { IViewCategoryState } from './viewCategoryContext';

export const viewCategoryReducer = (state: IViewCategoryState, action: TViewCategoryAction): IViewCategoryState => {
	switch (action.type) {
		case ViewCategoryActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetchData,
			};
		case ViewCategoryActionTypes.SET_CATEGORY_FULL_INFO:
			return {
				...state,
				categoryFullInfo: action.payload.categoryFullInfo,
				accessibleRestaurants: action.payload.accessibleRestaurants,
			};
		case ViewCategoryActionTypes.SET_RESTAURANT_ID_FOR_RESTAURANT_PROPS:
			return {
				...state,
				restaurantIdForRestaurantProps: action.payload.restaurantIdForRestaurantProps,
				restaurantProps: action.payload.restaurantProps,
			};
		case ViewCategoryActionTypes.SET_RESTAURANT_PROPS:
			return {
				...state,
				restaurantProps: action.payload.restaurantProps,
			};
		case ViewCategoryActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case ViewCategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
